const Checkbox = ({ id, name, checked = false, onChange, label, disabled = false, className = "", required = false }) => {
  return (
    <div className="tw-inline-flex tw-items-center">
      <label className="tw-relative tw-flex tw-items-center tw-cursor-pointer tw-m-0">
        {/* Hidden native checkbox for accessibility */}
        <input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} disabled={disabled} required={required} className="tw-sr-only peer" />

        {/* Custom checkbox design */}
        <div
          className={`tw-w-4 tw-h-4 tw-rounded-[4px] tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-200 
            ${checked ? "tw-bg-primary-purple-500 tw-border-transparent" : "tw-bg-white tw-border-gray-300"} 
            ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : "tw-cursor-pointer"}
            tw-border
            peer-focus:tw-ring-2 peer-focus:tw-ring-indigo-500 peer-focus:tw-ring-offset-2
            ${className}`}>
          {checked && (
            <svg className="tw-w-3 tw-h-3 tw-text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>

        {/* Label */}
        {label && <span className={`tw-ml-2 tw-text-gray-700 ${disabled ? "tw-opacity-50" : ""}`}>{label}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
